import { VueDelegate } from '../utils'
import { createInputComponents } from './inputs'
import { createIonNavVue } from './nav'

export function createComponents (delegate: VueDelegate): void {
  createInputComponents()
  createIonNavVue(delegate)
}
